// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomSection_wrapper__El2V6","overlay":"BottomSection_overlay__zuN6-","icon":"BottomSection_icon__aIPsp","text":"BottomSection_text__KQ7jW"};